import { Divider, Form } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import ButtonsToGenerateReports from '@/components/Reports/ButtonsToGenerateReports';
import { DefaultRouteTabs } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import ReturnedPurchasesForm from '@/components/Reports/PurchasesReports/ReturnedPurchasesForm';
import {
  QuestReportReturnedPurchaseFormValues,
  QuestReportReturnedPurchaseRequest,
  ReturnedPurchaseSituation,
} from '@/core/domain/questReport/Reports/Purchase/Purchase.types';
import { useReturnedPurchaseReport } from '@/core/domain/questReport/Reports/Purchase/Purchase.hook';
import { DateTimeFormat } from '@/utils/moment';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import { useReportGenerate } from '@/hooks';
import { ReportCallback } from '@/hooks/useReportGenerate';

export default function ReturnedPurchasesReportsPage({ route }: PageProps) {
  const [form] = Form.useForm<QuestReportReturnedPurchaseFormValues>();
  const { setFileLoading, setFileUnloading, fileLoading } = useFileLoading();
  const report = useReportGenerate();

  const generateReport = useReturnedPurchaseReport();

  console.log(fileLoading);

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);

    try {
      const formValues = await form.validateFields();

      const { initialDate, finalDate, situation, ...values } = formValues;

      const obj: QuestReportReturnedPurchaseRequest = {
        ...values,
        responseType:
          format === 'PDF' || format === 'REPORT_VIEW' ? 'PDF' : 'CSV',
        startDate: initialDate.format(DateTimeFormat),
        endDate: finalDate.format(DateTimeFormat),
        companiesIds: values.companiesIds?.toString(),
        situationCredit: situation.includes(
          ReturnedPurchaseSituation.situationCredit,
        ),
        situationDebit: situation.includes(
          ReturnedPurchaseSituation.situationDebit,
        ),
      };

      const result = await generateReport.mutateAsync(obj);

      if (callback) {
        callback(result);
      }
    } catch {}

    setFileUnloading(format);
  };

  const handleView = () => {
    handleGenerateReport('REPORT_VIEW', (result) =>
      report.openFile({
        result,
        fileName: 'compras_devolvidas.pdf',
        fileType: 'application/pdf',
      }),
    );
  };

  const handlePdf = () => {
    handleGenerateReport('PDF', (result) =>
      report.downloadFile({
        result,
        fileName: 'compras_devolvidas.pdf',
      }),
    );
  };

  const handleCsv = () => {
    handleGenerateReport('CSV', (result) =>
      report.downloadFile({
        result,
        fileName: 'compras_devolvidas.csv',
      }),
    );
  };

  return (
    <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
      <Helmet title={useIntl().formatMessage({ id: route.name })} />

      <Form form={form}>
        <ReturnedPurchasesForm />
      </Form>

      <Divider />

      <ButtonsToGenerateReports
        viewReport={handleView}
        generatePdf={handlePdf}
        generateCsv={handleCsv}
        loading={fileLoading}
      />
    </DefaultRouteTabs>
  );
}
